import React from 'react';
import {DOC_EMP_STATUS, DOCUMENT_BORDER_SIZE, DOCUMENT_FORMAT, MASTER_DATA_ACTION} from '../../common/constant';
import {getUserInfoObject} from "ubs-framework/v2/common/selector";
import moment from "moment";
import {PAGINATION} from "ubs-framework/v2/common/constant";
import {getCurrentFinancialYear, htmlToTag} from '../../common/functions/common';


export const startDate = new Date(moment().subtract(6, 'days').set({'hour': 0, 'minute': 0, 'second': 0}));
export const endDate = new Date(moment().set({'hour': 0, 'minute': 0, 'second': 0}));

const initialState = {
    isSystemAdmin: false,
    socketId: '',
    orgId: '',
    attendanceGEOFencing: {},
    loginMethod: {},
    subCompanyList: [],
    ownerId: [],
    branchList: [],
    businessUnitList: [],
    costCenterList: [],
    bandList: [],
    segmentList: [],
    hubList: [],
    territoryList: [],
    regionList: [],
    gradeList: [],
    workAreaList: [],
    degreeList: [],
    handlingUnitList: [],
    categoryList: [],
    departmentList: [],
    activityList: [],
    assetCategoryList: [],
    assetRequestModal: null,
    assetConditionList:[],
    assetTagList: [],
    assetTConditionList: [],
    subDepartmentList: [],
    employeeStatusList: [],
    familyPayload: [],
    idProofList: [],
    jobTitleList: [],
    employeeList: [],
    attendanceType: [],
    users: {},
    openSidebar: false,
    pageCount: '',
    employeeListCurrentPage: PAGINATION.CURRENT_PAGE,
    uac: null,
    pmsUAC: null,
    validUser: false, // this key will true only from response of onboarding valid user
    access: null,
    shiftList: [],
    weekendList: [],
    breakList: [],
    announcement: {isNewPost: false, lastActive: new Date()},
    documents: {
        letterTypeList: [],
        letterList: [],
        document: {
            name: '',
            letterType: '',
            description: '',
            paperSize: DOCUMENT_FORMAT[1],
            orientation: 'portrait',
            isPageMargins: true,
            pageMargin: {
                top: 10,
                right: 10,
                bottom: 10,
                left: 10
            },
            isSelectableHeaderAndFooter: true,
            isBorderSize: false,
            borderSize: DOCUMENT_BORDER_SIZE[0],
            isPageNumber: false,
            isbodyContentEmpty: true,
            pageNumberPosition: {label: 'Footer', value: 'footer'},
            pageNumberAlignment: {label: 'Center', value: 'center'},
            placeHolders: [],
            headerContent: '',
            headerContentHeight: 0,
            footerContent: '',
            footerContentHeight: 0,
            bodyContent: '',
            removeFiles: [],
        },
        addPlaceHolder: {
            key: '',
            id: ''
        },
        assignedEmp: {
            type: DOC_EMP_STATUS[0].value,
            searchText: '',
            refresh: false
        },
        authorFields: [],
        signatureModal: {
            openModal: false,
            editSignatureId: null,
        },
        otherEmployee: {
            loading: false,
            error: false,
            data: {},
            documentId: "",
        },
        sendReminderUsers: {},
        userSignatureStatus: {},
        warningPopup: false,
        loader: false,
        isShowCalculate: false,
        placeHoldersList: [],
    },
    inboxList: [],
    inboxFeedbackRequestFilter: 'active',
    inboxSurveyRequestFilter: 'active',
    inboxIncomeTaxFilter: 'active',
    userPayrollId: "",
    insuranceInfo: [],
    covidVaccinationInfo: [],
    insuranceReportList: [],
    insuranceTypeList: {
        total: 0,
        list: []
    },
    badgesList: [],
    feedbackTypeList: [],
    coreValuesList: [],
    praiseFeedbackCount: 0,
    referralsFilter: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        referredFor: '',
        referredBy:'',
        date: ''
    },
    salarySlipEmployee: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        month: '',
        year: { label: getCurrentFinancialYear(), value: getCurrentFinancialYear() },
        payrollType: 1,
    },
    ticketCategory: [],
    ticketPriority: [],
    ticketStatus: [],
    ticketTags: [],
    ticketUsers: [],
    ticketActivity: [],
    zoneList: [],
    locationBillingTypeList:[],
    clusterList: [],
    subLocationList:[],
    industryList:[],
    userObj: {},
    findUserIdsList: [],
    accessLevelObj: {},
    findAccessLevelIdsList: [],
    chatInfo: {},
    commentCounter: [],
    dashboardWidgetsSidebar: false,
    dashboardWidgets: {},
    bioMatrixDevice: false,
    welComeKit: {},
    onBoardingFields: {},
    showSalary: {
        pin: false,
        show: false
    },
    moodPopup: {},
    clientList: [],
    paymentBar: {},
    currencyList: [],
    indiaState: [],
    attendanceColumnOption: [],
    surveyData:[],
    allValues: {
        isMultiLevelApproval: false,// Boolean | required // this key replaced with 'approvalRequired' key
        // approvalLevelOne: [
        //     // {
        //     //     type: '', Number | required | [1|2] [USER|UAC]
        //     //     _id: '' //ObjectId | required
        //     // }
        // ],// ObjectArray | optional
        /** for Multiple level approval; */
        multiLevelApprovalData: {
            approval: [
                // {
                //     "auto_approval": false, // Boolean | required | default false
                //      days: 1 //  leave auto approved after- days | default 0
                //      level:1 [1 to 8]  Number | required
                //      _id: "64dc5f571b71fb1223ff5c8f"
                //     "assignUser": [
                //         {
                //             "_id": "635f855538dd310f3743c461",  //ObjectId | required
                //             "type": 2, // Number | required | [1|2] [USER|UAC]
                //             "uacId": "635f855538dd310f3743c461"  //ObjectId | required
                //         },
                //         {
                //             "type": 1,
                //             "_id": "6368c65181075a1df52e6bad",
                //             "uacId": "6368c65181075a1df52e6bad"
                //         }
                //     ],
                // },
            ]
        }
    },
    calenderViewMapData: {
        loading: true,
        data: [],
        totalRecords: 0
    },
    productivityLocation: [],
    assetActionData: null,
    mheProductivity: {editData: null}
};

const mergeAdditional = (payload) => {
    const masterArray = []
    payload?.users?.forEach(e => {
        if (payload?.additional && payload?.probation && payload?.bond) {
            const additional = payload?.additional.find(a => a.user === e._id)
            const probation = payload?.probation.find(a => a.user === e._id)
            const bond = payload?.bond.find(a => a.user === e._id)
            masterArray.push({...e, ...additional, ...probation, ...bond})
        } else if (payload?.additional && payload?.bond) {
            const additional = payload?.additional.find(a => a.user === e._id)
            const bond = payload?.bond.find(a => a.user === e._id)
            masterArray.push({...e, ...additional, ...bond})
        } else if (payload?.additional && payload?.probation) {
            const additional = payload?.additional.find(a => a.user === e._id)
            const probation = payload?.probation.find(a => a.user === e._id)
            masterArray.push({...e, ...additional, ...probation})
        } else if (payload?.additional && payload?.resignation) {
            const additional = payload?.additional.find(a => a.user === e._id)
            const resignation = payload?.resignation.find(a => a.user === e._id)
            masterArray.push({...e, ...additional, ...resignation})
        } else if (payload?.additional) {
            const additional = payload?.additional.find(a => a.user === e._id)
            masterArray.push({...e, ...additional})
        } else masterArray.push(e)
    })
    return masterArray
}

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'ON_BOARDING_AUTHENTICATE': {
            const data = {}
            if (action.payload) data.orgId = action.payload.orgId
            return {...state, ...data , validUser: true};
        }
        case 'AUTHENTICATE': {
            const data = {}
            if (action.payload) {
                data.planAccess = action.payload.planAccess
                data.orgId = action.payload.orgId
                data.isAdmin = action.payload.isAdmin
            }
            return {...state,
                referralsFilter: {
                    ...state.referralsFilter,
                    referredBy: {
                        label: `${action.payload.firstName} ${action.payload.lastName}`,
                        name: `${action.payload.firstName} ${action.payload.lastName}`,
                        profileImage: action?.payload?.profileImage,
                        value: action.payload._id,
                        _id: action.payload._id,
                    }
                },
                ...data};
        }
        case 'PRODUCT_ACCESS_REMOVED': {
            return {...state, uac: null};
        }
        case 'GET_HRMS_MASTER_DATA': {
            console.log('UAACCC', action?.payload?.uac?.hrms)
            const branchList = action?.payload?.branchList
            const subCompanyList = JSON.parse(JSON.stringify(state.subCompanyList))
            action.payload?.subCompanyList?.forEach(e => subCompanyList.push({...e, label: e?.company, value: e?._id}))

            /***
             * uac.employeeVisibility === 1 means that the user is manager with ALL EMPLOYEE visibility
             * uac.employeeVisibility === 4 means that the user is manager with DIRECT REPORTING visibility
             * uac.employeeVisibility === 5 means that the user is manager with DIRECT_INDIRECT REPORTING visibility
             */
            const visibilityFlag = !(state?.isAdmin || action?.payload?.isSystemAdmin || action.payload?.uac?.employeeVisibility === 1 || !action?.payload?.isSetOrgVisibilityForDR);
            branchList.map(e => {
                if (!visibilityFlag) {
                    e.isVisible = true;
                } else {
                    // Check employee visibility first 
                    e.isVisible = action?.payload?.visibility?.employeeVisibility?.findIndex(a => a?.location === e?._id) !== -1;
                    
                    // If not found in employee visibility, check location visibility
                    if (!e.isVisible) {
                        e.isVisible = action?.payload?.visibility?.visibilityLocation?.includes(e?._id);
                    }
                }
                return e;
            });

            subCompanyList.map(e => {
                if (!visibilityFlag) {
                    e.isVisible = true; 
                } else {
                    // Check employee visibility first
                    e.isVisible = action?.payload?.visibility?.employeeVisibility?.findIndex(a => a?.subCompany === e?._id) !== -1;
                    
                    // If not found in employee visibility, check subCompany visibility
                    if (!e.isVisible) {
                        e.isVisible = action?.payload?.visibility?.visibilitySubCompany?.includes(e?._id);
                    }
                }
                return e;
            });
            return {
                ...state,
                attendanceGEOFencing: state?.planAccess?.hrms?.geoFencing?.value ? action.payload?.attendanceGEOFencing : [],
                subCompanyList: subCompanyList.filter((v, i, a) => a.findIndex(t => (t._id === v._id)) === i),
                branchList: branchList.filter((v, i, a) => a.findIndex(t => (t._id === v._id)) === i),
                isSystemAdmin: action.payload?.isSystemAdmin,
                isEmployeeLastWorkingDay: action.payload?.isEmployeeLastWorkingDay,
                isRevokeApproval: action.payload?.isRevokeApproval,
                employeeVisibility: action.payload?.uac?.employeeVisibility,
                basicSetting: action.payload?.basicSetting,
                degreeList: action.payload?.degreeList,
                workAreaList: action.payload?.workAreaList,
                handlingUnitList: action.payload?.handlingUnitList,
                categoryList: action.payload?.categoryList,
                departmentList: action.payload?.deparmentList,
                assetCategoryList: action.payload?.assetCategoryList,
                assetTagList: action.payload?.assetTagList,
                assetConditionList: action.payload?.assetConditionList,
                activityList: action.payload?.activityList,
                subDepartmentList: action.payload?.subDepartmentList,
                employeeStatusList: action.payload?.employeeStatusList,
                idProofList: action.payload?.idProofList,
                jobTitleList: action.payload?.jobTitleList,
                addColumnOption: action.payload?.option?.employeeTabView,
                familyPayload: action.payload?.familyInfo,
                uac: action?.payload?.uac?.hrms || null,
                pmsUAC: action?.payload?.uac?.pms || null,
                uacID: action?.payload?.uac?._id,
                startFinancialYear: action?.payload?.startFinancialYear,
                shiftSetting: {...action?.payload?.shiftSetting,
                    isPMSBind: Boolean(action?.payload?.shiftSetting?.isPMSBind) && state?.planAccess?.pms?.default?.access,
                    isTaskList: Boolean(action?.payload?.shiftSetting?.isTaskList) && state?.planAccess?.pms?.default?.access,
                    skipCaptcha: state?.planAccess?.hrms?.recaptcha?.value ? Boolean(action?.payload?.shiftSetting?.skipCaptcha) : true,
                    taskListCount: state?.planAccess?.pms?.default?.access ? action?.payload?.shiftSetting?.taskListCount : 0
                },
                isGEO: action?.payload?.isGEO,
                userType: action?.payload?.uac?.userType,
                currentJobInfo: action?.payload?.currentJobInfo,
                ownerId: action?.payload?.ownerId,
                inboxSettings: action?.payload?.inboxSettings,
                insuranceInfo: action?.payload?.insuranceInfo,
                insuranceTypeList: action?.payload?.insuranceTypeList,
                insuranceReportList: action?.payload?.insuranceReportList,
                attendanceType: action?.payload?.attendanceType?.filter(e => e?.attendanceTypeAndReason !== 2),
                attendanceReason: action?.payload?.attendanceType?.filter(e => e?.attendanceTypeAndReason === 2),
                loginMethod: {
                    ...action?.payload?.loginMethod,
                    FACE_CLOCK_IN: Boolean(action?.payload?.loginMethod?.FACE_CLOCK_IN && state?.planAccess?.hrms?.faceScan?.value),
                    BIOMETRIC: Boolean(action?.payload?.loginMethod?.BIOMETRIC && state?.planAccess?.hrms?.biometricsIntegration?.value),
                    GEO_TAGGING: Boolean(action?.payload?.loginMethod?.GEO_TAGGING && state?.planAccess?.hrms?.geoTagging?.value),
                    LIVE_TRACKING: Boolean(action?.payload?.loginMethod?.LIVE_TRACKING && state?.planAccess?.hrms?.routeMap?.value)},
                onboardingSectionList: action?.payload?.onboardingSectionList?.results || [],
                covidVaccinationInfo: action?.payload?.covidVaccinationInfo || [],
                ticketCategory: action?.payload?.ticketCategory,
                ticketPriority: action?.payload?.ticketPriority,
                ticketStatus: action?.payload?.ticketStatus,
                ticketTags: action?.payload?.ticketTags,
                ticketUsers: action?.payload?.ticketUsers,
                ticketActivity: action?.payload?.ticketActivity,
                zoneList: action?.payload?.zoneList,
                locationBillingTypeList: action?.payload?.locationBillingTypeList,
                clusterList: action?.payload?.clusterList,
                subLocationList: action?.payload?.subLocationList,
                industryList: action?.payload?.industryList,
                productivityLocation: action?.payload?.branchList,
                productivityUAC: {
                    isOperationManager: action?.payload?.isOperationManager,
                    isReportingManager: action?.payload?.isReportingManager
                },
                isSetOrgVisibilityForDR: action?.payload?.isSetOrgVisibilityForDR,
                visibility: action?.payload?.visibility
            };
        }
        case 'UPDATE_HRMS_MASTER_DATA': {
            const key = Object.keys(action.payload?.payload)?.[0]
            const value = action.payload?.payload?.[key]
            let localState = null
            if (state[key]) localState = JSON.parse(JSON.stringify(state[key]));

            switch (action.payload.action) {
                case MASTER_DATA_ACTION.ADD : {
                    localState?.push(value)
                    break;
                }
                case MASTER_DATA_ACTION.UPDATE : {
                    localState = localState?.map(e => {
                        if (e._id === value?._id) return {...e, ...value}
                        else return e
                    })
                    break;
                }
                case MASTER_DATA_ACTION.REPLACE : {
                    localState = value
                    break;
                }
                case MASTER_DATA_ACTION.DELETE : {
                    localState = localState?.filter(e => e._id !== value?._id)
                    break;
                }
            }

            return {...state, [key]: localState};
        }
        case 'UPDATE_MASTER_SETTINGS': {
            const localState = {}
            if (action.payload?.hasOwnProperty('isSetOrgVisibilityForDR')) {
                localState.isSetOrgVisibilityForDR = action.payload?.isSetOrgVisibilityForDR
            }
            return {...state, ...localState};
        }
        case 'GET_CURRENT_TIMING': {
            return {...state, currentTiming: action.payload};
        }
        case 'GET_ORG_STRUCTURE': {
            const businessUnitList = action.payload?.businessUnitList.map(ele => ({ ...ele, label: ele.name, value: ele._id })) || []
            const costCenterList = action.payload?.costCenterList.map(ele => ({ ...ele, label: ele.name, value: ele._id })) || []
            const bandList = action.payload?.bandList.map(ele => ({ ...ele, label: ele.name, value: ele._id })) || []
            const segmentList = action.payload?.segmentList.map(ele => ({ ...ele, label: ele.name, value: ele._id })) || []
            const hubList = action.payload?.hubList.map(ele => ({ ...ele, label: ele.name, value: ele._id })) || []
            const regionList = action.payload?.regionList.map(ele => ({ ...ele, label: ele.name, value: ele._id })) || []
            const territoryList = action.payload?.territoryList.map(ele => ({ ...ele, label: ele.name, value: ele._id })) || []
            const gradeList = action.payload?.gradeList.map(ele => ({ ...ele, label: ele.name, value: ele._id })) || []
            return {...state, businessUnitList, costCenterList, bandList, segmentList, hubList, regionList, territoryList, gradeList };
        }
        case 'GET_PAYMENT_BAR_DATA': {
            return {...state, paymentBar: action.payload};
        }
        case 'GET_TERRITORY_DATA': {
            return {...state, currencyList: action.payload};
        }
        case 'SET_INDIA_STATE': {
            return {...state, indiaState: action.payload};
        }
        case 'SET_WORKSPACE_LIST': {
            const localState = {};
            
            const visibilityFlag = (state?.isAdmin || state?.isSystemAdmin || state?.employeeVisibility === 1 || !state?.isSetOrgVisibilityForDR);
            const subCompanyList = JSON.parse(JSON.stringify(state.subCompanyList))
            if (action.payload?.length) {
                const data = action.payload.find(e => e.orgId === state.orgId)
                if (data) {
                    data.label = data.company
                    data.value = data._id
                    data.isVisible = visibilityFlag
                    subCompanyList.unshift(data)
                }
                localState.subCompanyList = subCompanyList.filter((v, i, a) => a.findIndex(t => (t._id === v._id)) === i)
            }

            return {...state, ...localState};
        }
        case 'UPDATE_SUB_COMPANY': {
            const localState = {};
            let subCompanyList = JSON.parse(JSON.stringify(state.subCompanyList))
            if (action.action === 'add') {
                subCompanyList.push({...action.payload, label: action.payload?.company, value: action.payload?._id})
                localState.subCompanyList = subCompanyList.filter((v, i, a) => a.findIndex(t => (t._id === v._id)) === i)
            }

            if (action.action === 'update') {
                action.payload.label = action.payload?.company
                subCompanyList = subCompanyList.map(e => {
                    if (e.value === action.payload?._id) return {...e, ...action.payload}
                    else return e
                })
                localState.subCompanyList = subCompanyList.filter((v, i, a) => a.findIndex(t => (t._id === v._id)) === i)
            }
            if (action.action === 'delete') {
                localState.subCompanyList = subCompanyList.filter(e => e.value !== action.payload?._id)
            }
            return {...state, ...localState};
        }
        case 'GET_EMPLOYEE_DATA': {
            return {
                ...state,
                employeeList: action.payload?.result ? action.payload?.result : mergeAdditional(action.payload),
                pageCount: action?.payload?.totalRecords,
                currentPage: action?.payload?.currentPage
            };
        }
        case 'SET_ASSET_REQUEST_MODAL': {
            return {...state, assetRequestModal: action.payload ? {...action.payload} : null};
        }
        case 'SET_SHIFT_LIST': {
            const visibilityFlag = !(state?.isAdmin || state?.isSystemAdmin || state?.employeeVisibility === 1 || !state?.isSetOrgVisibilityForDR);

            action.payload?.shiftList.map(e => {
                if (!visibilityFlag) {
                    e.isVisible = true;
                } else {
                    // If not found in employee visibility, check location visibility
                    if (!e.isVisible) {
                        if(!e?.locationIds) e.locationIds = []
                        e.isVisible = !!e?.locationIds?.includes("all") || e.locationIds?.length === 0 || e.locationIds?.some(id => state?.visibility?.visibilityLocation.includes(id) || state?.visibility?.employeeVisibility?.findIndex(a => a?.location === id) !== -1);
                    }
                }
                return e;
            });

            return {
                ...state,
                shiftList: action.payload?.shiftList,
            };
        }
        case 'SET_WEEKEND_LIST': {
            return {
                ...state,
                weekendList: action.payload?.weekendList,
            };
        }
        case 'SET_BREAK_LIST': {
            return {
                ...state,
                breakList: action.payload?.rows,
            };
        }
        case 'SET_ANNOUNCEMENT': {
            return {...state, announcement: {...state.announcement, ...action.payload}};
        }
        case 'GET_PERTICULAR_EMPLOYEE': {
            const files = []
            action.payload.files && action?.payload?.files?.map(e => {
                files[e._id] = e;
                return e;
            });
            return {
                ...state,
                files,
                allPayloads: action.payload,
                insuranceInfo: action?.payload?.insuranceInfo,
                insuranceTypeList: action?.payload?.insuranceTypeList,
                insuranceReportList: action?.payload?.insuranceReportList,
                covidVaccinationInfo: action?.payload?.covidVaccinationInfo,
            };
        }
        case 'CLEAR_PAYLOAD' : {
            return {...state, allPayloads: null}
        }
        case 'UPDATE_ALL_PAYLOADS': {
            return {
                ...state,
                allPayloads: {...state?.allPayloads, ...action.payload}
            }
        }
        case 'GET_EMPLOYEE_OPTION': {
            return {
                ...state,
                addColumnOption: action.payload.values
            };
        }
        case 'GET_ATTENDANCE_OPTION': {
            return {...state, attendanceColumnOption: action.payload.values};
        }
        case 'GET_SURVEY_DATA': {
            return {...state, surveyData: action.payload};
        }
        case 'UPDATE_JOBLIST': {
            let localState = JSON.parse(JSON.stringify(state?.jobTitleList));
            let tempList = localState?.concat(action?.payload?.newTitle)
            return {
                ...state,
                jobTitleList: tempList
            };
        }
        case 'UPDATE_CATEGORY_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.categoryList));
            let tempList = localState?.concat(action?.payload?.category)
            return {
                ...state,
                categoryList: tempList
            };
        }
        case 'UPDATE_DEPARTMENT_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.departmentList));
            let tempList = localState?.concat(action?.payload?.department)
            return {
                ...state,
                departmentList: tempList
            };
        }
        case 'UPDATE_SUB_DEPARTMENT_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.subDepartmentList));
            let tempList = localState?.concat(action?.payload?.subDepartment)
            return {
                ...state,
                subDepartmentList: tempList
            };
        }
        case 'UPDATE_BUSINESS_UNIT_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.businessUnitList));
            let tempList = localState?.concat(action?.payload?.businessUnitList)
            return {
                ...state,
                businessUnitList: tempList
            };
        }
        case 'UPDATE_COST_CENTER_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.costCenterList));
            let tempList = localState?.concat(action?.payload?.costCenterList)
            return {
                ...state,
                costCenterList: tempList
            };
        }
        case 'UPDATE_BAND_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.bandList));
            let tempList = localState?.concat(action?.payload?.bandList)
            return {
                ...state,
                bandList: tempList
            };
        }
        case 'UPDATE_SEGMENT_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.segmentList));
            let tempList = localState?.concat(action?.payload?.segmentList)
            return {
                ...state,
                segmentList: tempList
            };
        }
        case 'UPDATE_HUB_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.hubList));
            let tempList = localState?.concat(action?.payload?.hubList)
            return {
                ...state,
                hubList: tempList
            };
        }
        case 'UPDATE_TERRITORY_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.territoryList));
            let tempList = localState?.concat(action?.payload?.territoryList)
            return {
                ...state,
                territoryList: tempList
            };
        }
        case 'UPDATE_REGION_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.regionList));
            let tempList = localState?.concat(action?.payload?.regionList)
            return {
                ...state,
                regionList: tempList
            };
        }
        case 'UPDATE_GRADE_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.gradeList));
            let tempList = localState?.concat(action?.payload?.gradeList)
            return {
                ...state,
                gradeList: tempList
            };
        }
        case 'UPDATE_EMPLOYEE_STATUS_LIST': {
            let localState = JSON.parse(JSON.stringify(state?.employeeStatusList));
            let tempList = localState?.concat(action?.payload?.status)
            return {
                ...state,
                employeeStatusList: tempList
            };
        }
        case 'INSURANCE_TYPE_LIST': {
            return {
                ...state,
                insuranceTypeList: {...state.insuranceTypeList, ...action?.payload}

            };
        }
        case 'INSURANCE_REPORT_LIST': {
            return {
                ...state,
                insuranceReportList: action?.payload
            };
        }
        case 'UPDATE_INSURANCE_LIST': {
            const localState = {};
            let insuranceInfo = JSON.parse(JSON.stringify(state.insuranceInfo));
            switch (action.payload.action) {
                case 'add': {
                    delete action.payload.data.createdAt
                    delete action.payload.data.updatedAt
                    delete action.payload.data.result
                    insuranceInfo.push(action.payload.data);
                    localState.insuranceInfo = insuranceInfo;
                    break;
                }
                case 'update': {
                    insuranceInfo = action.payload.data;
                    localState.insuranceInfo = insuranceInfo;
                    break;
                }
                case 'delete': {
                    localState.insuranceInfo = [...action.payload.data];
                    break;
                }
            }
            return {
                ...state,
                // insuranceInfo: action.payload
                ...localState
            };
        }
        case 'UPDATE_COVID_LIST': {
            const localState = {};
            let covidVaccinationInfo = JSON.parse(JSON.stringify(state.covidVaccinationInfo));
            switch (action.payload.action) {
                case 'add': {
                    delete action.payload.data.createdAt
                    delete action.payload.data.updatedAt
                    delete action.payload.data.result
                    covidVaccinationInfo.push(action.payload.data);
                    localState.covidVaccinationInfo = covidVaccinationInfo;
                    break;
                }
                case 'update': {
                    covidVaccinationInfo = action.payload.data;
                    localState.covidVaccinationInfo = covidVaccinationInfo;
                    break;
                }
                case 'delete': {
                    localState.covidVaccinationInfo = [...action.payload.data];
                    break;
                }
            }
            return {
                ...state,
                ...localState
            };
        }
        case 'ACCESS_LEVEL_ONBOARD': {
            return {
                ...state,
                access: action.payload.access
            };
        }

        case 'OPEN_SIDEBAR': {
            return {...state, openSidebar: action.payload};
        }

        case 'LOCATION_INFO': {
            const localState = {}
            const branchList = JSON.parse(JSON.stringify(state.branchList))
            if (action.payload.action === 'add') {
                branchList.push({name: action.payload.location.name, _id: action.payload.location._id})
                localState.branchList = branchList
            } else if (action.payload.action === 'update') {
                localState.branchList = branchList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.branchList = branchList.filter(e => e._id !== action.payload._id);
            } else if (action.payload.action === 'active') {
                if (branchList.findIndex(e => e?._id === action?.payload?._id) > -1) {
                    localState.branchList = branchList?.filter(e => e?._id !== action?.payload?._id);
                } else {
                    branchList.push({name: action?.payload?.LocationInfo?.name, _id: action?.payload?.LocationInfo?._id})
                    localState.branchList = branchList
                }
            }
            return {...state, ...localState};
        }
        case 'LOCATION_BILLING_TYPE_INFO': {
            const localState = {}
            const locationBillingTypeList = JSON.parse(JSON.stringify(state.locationBillingTypeList))
            if (action.payload.action === 'add') {
                locationBillingTypeList.push({name: action.payload.name, _id: action.payload._id})
                localState.locationBillingTypeList = locationBillingTypeList
            } else if (action.payload.action === 'update') {
                localState.locationBillingTypeList = locationBillingTypeList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.locationBillingTypeList = locationBillingTypeList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'SUB_LOCATION_REPORT': {
            const localState = {}
            const subLocationList = JSON.parse(JSON.stringify(state.subLocationList))
            if (action.payload.action === 'add') {
                subLocationList.push({name: action.payload.name, _id: action.payload._id})
                localState.subLocationList = subLocationList
            } else if (action.payload.action === 'update') {
                localState.subLocationList = subLocationList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.subLocationList = subLocationList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'DEGREE_INFO': {
            const localState = {}
            const degreeList = JSON.parse(JSON.stringify(state.degreeList))
            if (action.payload.action === 'add') {
                degreeList.push({name: action.payload.name, _id: action.payload._id})
                localState.degreeList = degreeList
            } else if (action.payload.action === 'update') {
                localState.degreeList = degreeList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.degreeList = degreeList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'CATEGORY_INFO': {
            const localState = {}
            const categoryList = JSON.parse(JSON.stringify(state.categoryList))
            if (action.payload.action === 'add') {
                categoryList.push({name: action.payload.name, _id: action.payload._id})
                localState.categoryList = categoryList
            } else if (action.payload.action === 'update') {
                localState.categoryList = categoryList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.categoryList = categoryList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'BUSINESS_INFO': {
            const localState = {};
            const businessUnitList = Array.isArray(state.businessUnitList) ? JSON.parse(JSON.stringify(state.businessUnitList)) : [];
            switch (action.payload.action) {
                case 'add':
                    businessUnitList.push({ name: action.payload.name, _id: action.payload._id });
                    localState.businessUnitList = businessUnitList;
                    break;
                case 'update':
                    localState.businessUnitList = businessUnitList.map(e => {
                        if (e._id === action.payload._id) e.name = action.payload.name;
                        return e;
                    });
                    break;
                case 'remove':
                    localState.businessUnitList = businessUnitList.filter(e => e._id !== action.payload._id);
                    break;
                default:
                    return state; // If the action is not recognized, return the current state
            }
            return {...state, ...localState};
        }
        case 'COST_CENTER_INFO': {
            const localState = {}
            const costCenterList = JSON.parse(JSON.stringify(state.costCenterList))
            if (action.payload.action === 'add') {
                costCenterList.push({name: action.payload.name, _id: action.payload._id})
                localState.costCenterList = costCenterList
            } else if (action.payload.action === 'update') {
                localState.costCenterList = costCenterList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.costCenterList = costCenterList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'BANDS_INFO': {
            const localState = {}
            const bandList = JSON.parse(JSON.stringify(state.bandList))
            if (action.payload.action === 'add') {
                bandList.push({name: action.payload.name, _id: action.payload._id})
                localState.bandList = bandList
            } else if (action.payload.action === 'update') {
                localState.bandList = bandList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.bandList = bandList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'SEGMENT_INFO': {
            const localState = {}
            const segmentList = JSON.parse(JSON.stringify(state.segmentList))
            if (action.payload.action === 'add') {
                segmentList.push({name: action.payload.name, _id: action.payload._id})
                localState.segmentList = segmentList
            } else if (action.payload.action === 'update') {
                localState.segmentList = segmentList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.segmentList = segmentList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'HUB_INFO': {
            const localState = {}
            const hubList = JSON.parse(JSON.stringify(state.hubList))
            if (action.payload.action === 'add') {
                hubList.push({name: action.payload.name, _id: action.payload._id})
                localState.hubList = hubList
            } else if (action.payload.action === 'update') {
                localState.hubList = hubList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.hubList = hubList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'TERRITORY_INFO': {
            const localState = {}
            const territoryList = JSON.parse(JSON.stringify(state.territoryList))
            if (action.payload.action === 'add') {
                territoryList.push({name: action.payload.name, _id: action.payload._id})
                localState.territoryList = territoryList
            } else if (action.payload.action === 'update') {
                localState.territoryList = territoryList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.territoryList = territoryList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'REGION_INFO': {
            const localState = {}
            const regionList = JSON.parse(JSON.stringify(state.regionList))
            if (action.payload.action === 'add') {
                regionList.push({name: action.payload.name, _id: action.payload._id})
                localState.regionList = regionList
            } else if (action.payload.action === 'update') {
                localState.regionList = regionList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.regionList = regionList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'GRADE_INFO': {
            const localState = {}
            const gradeList = JSON.parse(JSON.stringify(state.gradeList))
            if (action.payload.action === 'add') {
                gradeList.push({name: action.payload.name, _id: action.payload._id})
                localState.gradeList = gradeList
            } else if (action.payload.action === 'update') {
                localState.gradeList = gradeList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.gradeList = gradeList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'DEPARTMENT_INFO': {
            const localState = {}
            const departmentList = JSON.parse(JSON.stringify(state.departmentList))
            if (action.payload.action === 'add') {
                departmentList.push({name: action.payload.name, _id: action.payload._id})
                localState.departmentList = departmentList
            } else if (action.payload.action === 'update') {
                localState.departmentList = departmentList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.departmentList = departmentList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'SUB_DEPARTMENT_INFO': {
            const localState = {}
            const subDepartmentList = JSON.parse(JSON.stringify(state.subDepartmentList))
            if (action.payload.action === 'add') {
                subDepartmentList.push({name: action.payload.name, _id: action.payload._id})
                localState.subDepartmentList = subDepartmentList
            } else if (action.payload.action === 'update') {
                localState.subDepartmentList = subDepartmentList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.subDepartmentList = subDepartmentList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'EMPLOYEE_STATUS_INFO': {
            const localState = {}
            const employeeStatusList = JSON.parse(JSON.stringify(state.employeeStatusList))
            if (action.payload.action === 'add') {
                employeeStatusList.push(action.payload)
                localState.employeeStatusList = employeeStatusList
            } else if (action.payload.action === 'update') {
                localState.employeeStatusList = employeeStatusList.map(e => {
                    if (e._id === action.payload._id) e = {...e, ...action.payload}
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.employeeStatusList = employeeStatusList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'FAMILY_INFO': {
            const localState = {}
            const familyPayload = JSON.parse(JSON.stringify(state.familyPayload))
            if (action.payload.action === 'add') {
                familyPayload.push({
                    name: action.payload.name,
                    _id: action.payload._id,
                    createdAt: action.payload.createdAt,
                    updatedAt: action.payload.updatedAt,
                    isDefault: action.payload.isDefault
                })
                localState.familyPayload = familyPayload
            } else if (action.payload.action === 'update') {
                localState.familyPayload = familyPayload.map(e => {
                    if (e._id === action.payload._id) {
                        e.name = action.payload.name
                        e.createdAt = action.payload.createdAt
                        e.updatedAt = action.payload.updatedAt
                        e.isDefault = action.payload.isDefault
                    }
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.familyPayload = familyPayload.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'ID_PROOF_INFO': {
            const localState = {}
            const idProofList = JSON.parse(JSON.stringify(state.idProofList))
            if (action.payload.action === 'add') {
                idProofList.push({name: action.payload.name, _id: action.payload._id})
                localState.idProofList = idProofList
            } else if (action.payload.action === 'update') {
                localState.idProofList = idProofList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.idProofList = idProofList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'JOB_TITLE_INFO': {
            const localState = {}
            const jobTitleList = JSON.parse(JSON.stringify(state.jobTitleList))
            if (action.payload.action === 'add') {
                jobTitleList.push({
                    name: action.payload.name,
                    _id: action.payload._id,
                    createdBy: action.payload.createdBy
                })
                localState.jobTitleList = jobTitleList
            } else if (action.payload.action === 'update') {
                localState.jobTitleList = jobTitleList.map(e => {
                    if (e._id === action.payload._id) {
                        e.name = action.payload.name
                        e.createdBy = action.payload.createdBy
                    }
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.jobTitleList = jobTitleList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'LOCATION_ACTIVITY': {
            const localState = {}
            const activityList = JSON.parse(JSON.stringify(state.activityList))
            if (action.payload.action === 'add') {
                activityList.push({name: action.payload.name, _id: action.payload._id})
                localState.activityList = activityList
            } else if (action.payload.action === 'update') {
                localState.activityList = activityList.map(e => {
                    if (e._id === action.payload._id) e.name = action.payload.name
                    return e
                })
            } else if (action.payload.action === 'remove') {
                localState.activityList = activityList.filter(e => e._id !== action.payload._id);
            }
            return {...state, ...localState};
        }
        case 'UPDATE_INBOX_LIST' : {
            return {...state, inboxList: action.payload};
        }
        case 'GEO_UPDATE': {
            return {...state, isGEO: action?.payload?.isGEO}
        }
        case 'UPDATE_DOCUMENTS': {
            let documents = JSON.parse(JSON.stringify({...state.documents}))
            if (action.payload.action === 'letter-type-list') {
                documents.letterTypeList = action.payload.letterTypeList
            } else if (action.payload.action === 'letter-list') {
                if (action.payload.hasOwnProperty('isDeleted')) {
                    action.payload.letterList = documents.letterList.map(letter => {
                        if (action.payload?._id) {
                            if (action.payload._id === letter._id) letter.isDeleted = action.payload.isDeleted
                        } else letter.isDeleted = false
                        return letter
                    })
                }
                documents.letterList = action.payload.letterList
            } else if (action.payload.action === 'reset') {
                documents.document = initialState.documents.document
            } else if (action.payload.action === 'placeholders') {
                documents.placeHolders = action.payload.placeHolders
            } else if (action.payload.action === 'add-placeholders') {
                documents.addPlaceHolder = {...documents.addPlaceHolder, ...action.payload.addPlaceHolder}
                documents.placeHolders = action.payload.placeHolders
            } else if (action.payload.action === 'assigned-emp') {
                documents.assignedEmp = {...documents.assignedEmp, ...action.payload.data}
            } else if (action.payload.action === 'removeFiles') {
                documents.document.removeFiles.push(action.payload.data)
            } else if (action.payload.action === 'editSignatureId') {
                documents.signatureModal = {...documents.signatureModal, editSignatureId: action.payload.data,}
            } else if (action.payload.action === 'openSignatureModal') {
                documents.signatureModal = {...documents.signatureModal, openModal: action.payload.data,}
            } else if (action.payload.action === 'setDocumentData') {
                documents.otherEmployee.data = {...documents.otherEmployee.data, data: action.payload.data,}
            } else if (action.payload.action === 'send-reminder-data') {
                documents.sendReminderUsers = {...documents.sendReminderUsers, ...action.payload.data,}
            } else if (action.payload.action === 'user-signature-status') {
                documents.userSignatureStatus = {...documents.userSignatureStatus, ...action.payload.data,}
            } else if (action.payload.action === 'placeholders-list') {
                documents.placeHoldersList = [...documents.placeHoldersList, ...new Set(action.payload.placeHoldersList || [])];
            } else {
                documents.document = action.payload
            }
            if(documents.document.bodyContent){
                documents.document.bodyContent = htmlToTag(documents.document.bodyContent,documents?.placeHoldersList?.map(_=> `{{${_?.key}}}`));
            }
            return {...state, documents}
        }
        case 'SET_DOCUMENT_SAVE_WARNING': {
            return {...state, documents: {...state.documents, warningPopup: action?.payload}};
        }
        case 'SET_DOCUMENT_LOADER': {
            return {...state, documents: {...state.documents, loader: action?.payload}};
        }
        case 'SET_CALCULATION_TYPE': {
            return {...state, documents: {...state.documents, isShowCalculate: action?.payload}};
        }
        case 'SET_INBOX_FEEDBACK_FILTER': {
            return {...state, inboxFeedbackRequestFilter: action.payload};
        }
        case 'SET_INBOX_SURVEY_FILTER': {
            return {...state, inboxSurveyRequestFilter: action.payload};
        }
        case 'SET_INBOX_INCOME_TAX_FILTER': {
            return {...state, inboxIncomeTaxFilter: action.payload};
        }
        case 'SET_USER_PAYROLL_ID': {
            return {...state, userPayrollId: action?.payload?.userPayrollId};
        }
        case 'SET_BADGES_LIST': {
            return {...state, badgesList: action.payload};
        }
        case 'SET_FEEDBACKTYPE_LIST': {
            return {...state, feedbackTypeList: action.payload};
        }
        case 'SET_PRAISE_COUNT': {
            return {...state, praiseFeedbackCount: action.payload};
        }
        case 'SET_CORE_VALUE_LIST': {
            return {...state, coreValuesList: action.payload};
        }
        case 'FIND_MASTER_DATA_LIST': {
            return {
                ...state,
                ...(action?.payload?.findUserIdsList && {findUserIdsList: action?.payload?.findUserIdsList}),
                ...(action?.payload?.findAccessLevelIdsList && {findAccessLevelIdsList: action?.payload?.findAccessLevelIdsList}),
            }
        }
        case 'GET_MASTER_INFO_UPDATE': {
            const userObj = JSON.parse(JSON.stringify(state.userObj));
            const accessLevelObj = JSON.parse(JSON.stringify(state.accessLevelObj));

            // set user object
            if (action?.payload && action?.payload?.users?.length !== 0) {
                action?.payload?.users?.map(e => {
                    userObj[e._id] = getUserInfoObject(e)
                })
            }

            // set access level object
            if (action?.payload && action?.payload?.accessLevel?.length !== 0) {
                action?.payload?.accessLevel?.map(e => {
                    accessLevelObj[e._id] = e
                })
            }

            return {...state, userObj, accessLevelObj}
        }
        case 'SET_CHAT_INFORMATION': {
            return {...state, chatInfo: action?.payload};
        }
        case 'SET_COMMENT_COUNTER': {
            return {...state, commentCounter: action?.payload};
        }
        case 'SET_DASHBOARD_WIDGETS_SIDEBAR': {
            return {...state, dashboardWidgetsSidebar: action?.payload};
        }
        case 'SET_DASHBOARD_WIDGETS_ON_OFF': {
            return {...state, dashboardWidgets: action?.payload};
        }
        case 'SET_CANDIDATE_FETCH': {
            return {...state, welComeKit: action?.payload?.welComeKit, onBoardingFields: action?.payload?.fields};
        }
        case 'SET_SHOW_SALARY': {
            return {...state, showSalary: action?.payload};
        }
        case 'GET_SURVEY_MOOD_DATA': {
            return {...state, moodPopup: {...state.moodPopup, ...action.payload}};
        }
        case 'SET_BIO_MATRIX_DEVICE': {
            return {...state, bioMatrixDevice: action?.payload};
        }
        case 'REFERRALS_FILTER': {
            return {...state, referralsFilter: {...state.referralsFilter, ...action.payload}};
        }
        case 'SALARY_SLIP_EMPLOYEE': {
            return {...state, salarySlipEmployee: {...state.salarySlipEmployee, ...action.payload}};
        }
        case 'SET_ALL_VALUES': {
            return {...state, allValues: {...state.allValues, ...action.payload}, isChange: action.isChange || false}
        }
        case 'SET_CALENDER_VIEW_MAP_DATA': {

            let mapData = JSON.parse(JSON.stringify(state?.calenderViewMapData?.data))

            if (action?.payload?.currentPage === 1) {
                mapData = action?.payload?.data ?? []
            } else mapData.push(...action?.payload?.data)

            return {...state, calenderViewMapData: {...action.payload, data: mapData}};
        }
        case 'SET_CLIENT_LIST': {
            return {...state, clientList: action.payload};
        }
        case 'SET_PRODUCTIVITY_LOCATION_LIST': {
            return { ...state, productivityLocation: action.payload };
        }
        case 'SET_ASSET_ACTION_MODAL': {
            return {...state, assetActionData: action.payload};
        }


        default: {
            return state;
        }
    }
}
